import React, { createContext, useCallback, useContext, useState } from "react";
export const ShowPasswordContext = /*#__PURE__*/createContext({});
export const ShowPasswordProvider = ({
  children
}) => {
  const [globalShowPassword, setGlobalShowPassword] = useState(false);
  const globalTogglePassword = useCallback(e => {
    e?.preventDefault();
    setGlobalShowPassword(value => !value);
  }, []);
  return /*#__PURE__*/React.createElement(ShowPasswordContext.Provider, {
    value: {
      globalShowPassword,
      globalTogglePassword
    }
  }, children);
};
export function usePasswordToggle() {
  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = e => {
    e?.preventDefault();
    setShowPassword(value => !value);
  };
  const context = useContext(ShowPasswordContext);
  return {
    showPassword: context?.globalShowPassword ?? showPassword,
    togglePassword: context?.globalTogglePassword ?? togglePassword
  };
}
//# sourceMappingURL=ShowPasswordProvider.js.map